var App = App || {};

App.SiteSearch = (function () {
    "use strict";

    function init() {
        $(".site-header-search > .search-toggle").on("click", function () {
            setTimeout(
                function () {
                    $('.site-header-search__offcanvas').find('input').eq(0).focus();
                }, 400);
        });
    }

    return {
        init: init
    };
})();

$(function () {
    App.SiteSearch.init();
});
